module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/wow-slider/wow-fade-in-up/wow-fade-in-up.component.scss
// module id = ./src/app/features/wow-slider/wow-fade-in-up/wow-fade-in-up.component.scss
// module chunks = main